import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const ForReviewReasonFilter = ({ forReviewReasons = [], value = [], onChange }) => {
  const { t } = useTranslation()

  return (
    <div>
      <ComboBox
        menuItems={forReviewReasons?.map(r => ({ label: t(r.label), value: r.value }))}
        value={value || []}
        multiple
        fullWidth
        label={t('Motivo de revisión')}
        handleChange={e => onChange(e.target.value)}
      />
    </div>
  )
}

export default ForReviewReasonFilter
